import { css } from 'styled-components';

/**
 * Global styles you can use as baseline for your app.
 * 
 * @example
 * const GlobalStyle = createGlobalStyle`
  ${globalStyles}
`;
 */
export const globalStyles = css(
  ({ theme }) => css`
    @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,100..700;1,100..700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');

    html,
    body {
      font-family: ${theme.core.typography.fontFamily.regular};
      font-size: ${theme.core.typography.fontSize.base};
      color: ${theme.semantic.color['non-interactable'].fg.default};
      background-color: ${theme.semantic.color['non-interactable'].bg.cloudy};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    code {
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
    }

    a {
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }

    button {
      padding: 0;
      margin: 0;
      font-family: ${theme.core.typography.fontFamily.regular};
      cursor: pointer;
      background: transparent;
      border: none;

      &:disabled {
        cursor: not-allowed;
      }
    }

    ul,
    menu {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      margin: 0;
      appearance: none;
    }

    input[type='number'] {
      appearance: textfield;
    }

    input,
    textarea {
      font-family: ${theme.core.typography.fontFamily.regular};

      ::placeholder {
        opacity: 1;
      }
    }
  `,
);
